import "./CybersecurityCyberGenix.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Malwarebytes from "./sections/Malwarebytes";
import Nordpass from "./sections/Nordpass";
import Blog from "./sections/Blog";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
import Incogni from "./sections/Incogni";
import FsecurePromo from "./sections/FsecurePromo";
import TroopMessenger from "./sections/TroopMessenger";
import Dashlane from "./sections/Dashlane";
import McafeePromo from "./sections/McafeePromo";
export default function CybersecurityCyberGenixPage() {
  return <div>
      <Header />
      <Hero />
      <Malwarebytes />
      <Nordpass />
      <Incogni />
      <FsecurePromo />
      <McafeePromo />
      <TroopMessenger />
      <Dashlane id="dashlanepromo" />
      <Blog />
      <Contact />
      <Footer />
    </div>;
}